<template>
  <v-menu>
    <template #activator="{ on: deleteOn, attrs: deleteAttrs }">
      <slot
        name="activator"
        :on="deleteOn"
        :attrs="deleteAttrs"
      >
        <v-btn
          icon
          :ripple="false"
          v-bind="deleteAttrs"
          v-on="deleteOn"
        >
          <v-icon
            small
          >
            {{ icons.mdiTrashCanOutline }}
          </v-icon>
        </v-btn>
      </slot>
    </template>
    <template #default="{ menu: deleteMenu }">
      <v-card>
        <v-card-text>
          <slot name="message">
            <p>
              {{ message }}
            </p>
            <p>
              {{ warningMessage }}
            </p>
          </slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            small
            color="secondary"
            @click="deleteMenu.value = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            small
            color="error"
            @click="$emit('confirm')"
          >
            実行
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-menu>
</template>

<script>
import { mdiTrashCanOutline } from '@mdi/js'

export default {
  name: 'DeleteConfirmDialog',
  props: {
    icon: {
      type: String,
      default: 'mdiTrashCanOutline',
    },
    message: {
      type: String,
      default: '削除しますか？',
    },
    warningMessage: {
      type: String,
      default: 'この操作は取り消せません。',
    },
  },
  setup() {
    return {
      icons: {
        mdiTrashCanOutline,
      },
    }
  },
}
</script>
